module.exports = __webpack_public_path__ + "img/en-pc-s6.f4524c0a.png";